import React from 'react';
import DashboardTemplate from '@/components/templates/DashboardTemplate';

const DashboardPage = () => {
  return <DashboardTemplate>DashboardPage</DashboardTemplate>;
};

export default DashboardPage;
